import styled from "@emotion/styled";

import { touchOptimizedStyles } from "shared/components/common/base-link/styles";

import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

export const IconMenuContainer = styled.div<ResponsiveStyledProps>`
  cursor: pointer;

  path {
    fill: #000000;
  }

  ${touchOptimizedStyles}
  ${responsiveStyles}
`;
